const path='$board'

export const BOARD_ARTICLE_CURRENT = `${path}/article/current`